import React, { FC } from 'react';
import { Label, Props } from 'src/components/Surfaces/Label';

const BetaLabel: FC<Props> = () => {
  return (
    <Label attention small solid>
      Beta
    </Label>
  );
};

export default BetaLabel;
